export default __webpack_public_path__ + "static/media/bh.00da27ba.png";